import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createEvent, updateEvent, getEvent } from "./api";
import styles from "./Form.module.css";

export default function EventsAdd() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [venue, setVenue] = useState("");
  const [place, setPlace] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [image, setImage] = useState(null);
  const [existingImage, setExistingImage] = useState("");
  const [status, setStatus] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    if (id) {
      setEditId(id);
      getEvent(id).then((res) => {
        if (res.item) {
          setTitle(res.item.title || "");
          setDescription(res.item.description || "");
          setVenue(res.item.venue || "");
          setPlace(res.item.place || "");
          setEventDate(res.item.event_date || "");
          setEventTime(res.item.event_time || "");
          setExistingImage(res.item.image_path || "");
        }
      }).catch(() => {});
    }
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    setStatus("");

    if (!title || !description || !venue || !place || !eventDate) {
      setStatus("All fields are required");
      return;
    }

    const fd = new FormData();
    fd.append("title", title);
    fd.append("description", description);
    fd.append("venue", venue);
    fd.append("place", place);
    fd.append("event_date", eventDate);
    if (eventTime) fd.append("event_time", eventTime);
    if (image) fd.append("image", image);
    
    try {
      if (editId) {
        await updateEvent(editId, fd);
      } else {
        await createEvent(fd);
      }
      navigate("/admin/events");
    } catch (err) {
      setStatus(err.message || "Failed");
    }
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Add Event</h2>
      {status && <p className={styles.status}>{status}</p>}
      <form className={styles.grid} onSubmit={onSubmit}>
        <div className={styles.row}>
          <div className={styles.label}>Event Title</div>
          <input 
            className={styles.input} 
            placeholder="Enter Event Title" 
            value={title} 
            onChange={(e) => setTitle(e.target.value)} 
            required 
          />
        </div>
        
        <div className={styles.row}>
          <div className={styles.label}>Event Description</div>
          <textarea 
            className={styles.input} 
            placeholder="Enter Event Description" 
            value={description} 
            onChange={(e) => setDescription(e.target.value)} 
            required 
            rows="5"
          />
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Event Venue</div>
          <input 
            className={styles.input} 
            placeholder="Enter Event Venue (e.g., Community Hall)" 
            value={venue} 
            onChange={(e) => setVenue(e.target.value)} 
            required 
          />
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Place</div>
          <input 
            className={styles.input} 
            placeholder="Enter Place (e.g., City Name)" 
            value={place} 
            onChange={(e) => setPlace(e.target.value)} 
            required 
          />
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Event Date</div>
          <input 
            className={styles.input} 
            type="date" 
            value={eventDate} 
            onChange={(e) => setEventDate(e.target.value)} 
            required 
          />
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Event Time (Optional)</div>
          <input 
            className={styles.input} 
            type="time" 
            value={eventTime} 
            onChange={(e) => setEventTime(e.target.value)} 
          />
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Upload Event Image (Optional)</div>
          <input 
            className={styles.file} 
            type="file" 
            accept="image/*" 
            onChange={(e) => setImage(e.target.files?.[0] || null)} 
          />
          {existingImage && !image && (
            <div className={styles.preview}>
              <img src={existingImage} alt="Existing event" />
            </div>
          )}
        </div>

        <div className={styles.actions}>
          <button className={styles.button} type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
}
